import { CustomerRefundNoteForm } from 'domains/customer-refund/organisms'
import PropTypes from 'prop-types'

const propTypes = {
  refund: PropTypes.shape({
    cs_notes  : PropTypes.object,
    ops_notes : PropTypes.object
  }),
  handleSubmitNote: PropTypes.func
}

const CustomerRefundNoteView = ({ refund, handleSubmitNote }) => {

  const Notes = ( { notes } ) => {
    const arrayMessage = notes && Object.entries(notes) || []

    return arrayMessage.map(([ key,value ], index) => (
      <div key={ `note-message-${index}` } className='mb-3'>
        <div className='font-weight-bold small text-muted'>{ key }</div>
        <div>{ value }</div>
      </div>
    ))
  }

  return (
    <>

      <div>
        <h4>Customer Service</h4>
        <Notes notes={ refund.cs_notes }/>
        <div>
          <CustomerRefundNoteForm
            name={ 'cs_notes' }
            handleSubmitNote={ handleSubmitNote }
          />
        </div>
      </div>

      <div>
        <h4>Operations</h4>
        <Notes notes={ refund.ops_notes }/>
        <div>
          <CustomerRefundNoteForm
            name={ 'ops_notes' }
            handleSubmitNote={ handleSubmitNote }
          />
        </div>
      </div>

    </>
  )
}

CustomerRefundNoteView.propTypes = propTypes

export default CustomerRefundNoteView